import React, { useCallback, useRef } from 'react'
import { Button, Icon, Label } from 'semantic-ui-react'
import CustomPopup from '../customPopup'
import { MemoizeDisplayExchangeRatesList } from './displayExchangeRatesList'
import moment from 'moment'

 const ExchangeRates =({translate,DropDownReducer})=>{
    const popup=useRef()
    const exchangeRatePopup=useRef()
    const country = window.shipmentCountry==="ES"? "Spain":"Netherlands";
    
    const rateRenewWarning=React.useMemo(()=>{
        const firstDateOfNextMonth = moment().endOf('month').add(1, 'days');
        const daysBeforeEndDate = moment().endOf('month').subtract(3, 'days');
        const currentDate =moment(); 
        return moment(currentDate, 'DD-MM-YYYY').isBetween(daysBeforeEndDate,firstDateOfNextMonth,'days','[]') ? `${translate("ER_RENEW_MSG")} ${firstDateOfNextMonth.format('DD-MM-YYYY')}` : ''

    },[])
    const displayRenewWarning=useCallback(()=>(rateRenewWarning ? <Label  basic color='red' ><Icon color="red" name="warning sign"/> {rateRenewWarning}</Label>: null),[rateRenewWarning])
    return(
        <div className='exchangeRates'>
        {displayRenewWarning()}
        <Button size="mini"
        className='sv todo-button'
        onClick={()=>popup.current?.openPopup()} >
           {translate("EXCHANGE_RATES")}
        </Button>
        <CustomPopup 
        content={false}
        ref={popup} 
        className="confirmationPopup"
        header={<div>{`${translate("EXCHANGE_RATE_MODAL_HEADER")} ${country}?`}</div>}
        actions={
        <div className="actions">
          <Button  positive onClick={()=>{
            popup.current?.closePopup()
            exchangeRatePopup.current?.openPopup()
          }}>
          {translate("YES")}
        </Button>
        <Button negative onClick={()=>popup.current?.closePopup()}>
            {translate("NO")}
          </Button>
        </div>
      } />
       <CustomPopup 
        closeIcon
        onClose={()=>exchangeRatePopup.current?.closePopup()}
        content={true}
        description={<MemoizeDisplayExchangeRatesList displayRenewWarning={displayRenewWarning} displayRateRenewBtn={Boolean(rateRenewWarning)} DropDownReducer={DropDownReducer} />}
        ref={exchangeRatePopup} 
        className="exchangeRatePopup"
        />
      
      </div>

    )
}

const MemoizeExchangeRates=React.memo(ExchangeRates)
export {MemoizeExchangeRates}